var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstruction2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_206",
    "data-name": "Group 206",
    xmlns: "http://www.w3.org/2000/svg",
    width: 747.28,
    height: 462.177,
    viewBox: "0 0 747.28 462.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      :root {\n      --primary-color: #9138b0;\n      --secondary-color: #D9B0EA;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    width: 747.28,
    height: 462.177,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    width: 742.281,
    height: 457.177,
    rx: 36.218,
    transform: "translate(2.5 2.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    width: 684.796,
    height: 390.001,
    rx: 27.595,
    transform: "translate(31.242 36.088)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    d: "M437.678,216.308V173.127H394.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    d: "M309.6,216.308V173.127h43.181",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    d: "M309.6,258.021V301.2h43.181",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    d: "M437.678,258.021V301.2H394.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    cx: 217.065,
    cy: 23.704,
    rx: 217.065,
    ry: 23.704,
    transform: "translate(164.527 352.21)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    d: "M598.657,364.474c0,13.092-97.183,23.7-217.065,23.7s-217.065-10.612-217.065-23.7,97.183-23.7,217.065-23.7,217.065,10.612,217.065,23.7",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    cx: 217.065,
    cy: 23.704,
    rx: 217.065,
    ry: 23.704,
    transform: "translate(164.527 340.77)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction2);
export default __webpack_public_path__ + "static/media/instruction2.d49b521c3f708d799b035eaa3235566f.svg";
export { ForwardRef as ReactComponent };